export default __webpack_public_path__ + "static/image4-9b98f63e802cdc551f70d1de56fccc49.jpeg";